module.exports = __webpack_public_path__ + "i18n/ja.837d4ba42dee704e140e0171b6ca99cf.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1309
// module chunks = 59